import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {BulkActionIdSelector, BulkActionShownSelector, BulkActionTaskSelector} from 'src/components/bulk-tool/typedef';
import type {AppState} from 'src/store/typedef';

export const assignProductSeatSlice = getBulkActionSlice('assignProductSeatResult');
export const selectAssignProductSeatUuid: BulkActionIdSelector = (state: AppState) =>
    state.bulkUpdateResult.assignProductSeatResult.uuid;
export const selectAssignProductSeatShown: BulkActionShownSelector = (state: AppState) =>
    state.bulkUpdateResult.assignProductSeatResult.shown;
export const selectAssignProductSeatTask: BulkActionTaskSelector = (state: AppState) =>
    state.bulkUpdateResult.assignProductSeatResult.backgroundTask;
export const {setUuid, setShown, setBackgroundTask, clearResult} = assignProductSeatSlice.actions;
